import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { useEffect, ReactNode } from 'react'
import { rounaDisplay, rounaMono, rouna } from 'utils/fonts'

type ModalProps = {
  children: ReactNode
  disableOutsideClose?: boolean
  fullScreen?: boolean
  isOpen: boolean
  onClose: () => void
  panelClassNames?: string
  hideClose?: boolean
}

function Modal({
  children,
  disableOutsideClose = false,
  fullScreen = false,
  isOpen,
  onClose,
  panelClassNames,
  hideClose,
}: ModalProps) {
  useEffect(() => {
    document.documentElement.style.overflow = isOpen ? 'hidden' : 'auto'

    return () => {
      document.documentElement.style.overflow = 'auto'
    }
  }, [isOpen])

  const handleClose = () => {
    if (disableOutsideClose) return
    onClose()
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative z-40">
      <div
        className={`fixed inset-0 backdrop-blur-sm backdrop-brightness-[0.6] ${
          disableOutsideClose ? 'pointer-events-none' : ''
        }`}
        aria-hidden="true"
      />
      <div
        className={`fixed inset-0 flex items-center sm:justify-center ${
          fullScreen ? '' : 'sm:px-4'
        }`}
      >
        <DialogPanel
          className={`${rounaDisplay.variable} ${rouna.variable} ${
            rounaMono.variable
          } size-full bg-th-bkg-1 font-body ${
            fullScreen
              ? ''
              : 'thin-scroll p-4 sm:h-auto sm:max-h-[calc(100vh-124px)] sm:max-w-md sm:rounded-lg sm:border sm:border-th-bkg-3 sm:p-6'
          } relative ${panelClassNames} overflow-y-auto`}
        >
          <div className="h-full">{children}</div>
          {!hideClose ? (
            <button
              onClick={handleClose}
              className={`absolute right-4 top-4 text-th-fgd-4 focus:outline-none focus-visible:text-th-active ${
                fullScreen
                  ? 'sm:right-2 sm:top-2'
                  : 'sm:-top-0 sm:right-0 sm:flex sm:size-10 sm:items-center sm:justify-center'
              } md:hover:text-th-active`}
            >
              <XMarkIcon className="size-6" />
            </button>
          ) : null}
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default Modal
